<!--
  author: YangKun 杨昆
  目前负责人: 杨昆
  description: 券业务组件
-->
<template>
  <div class="v-coupon" @click="changeSelect(coupon.couponUuid)">
    <div
      class="new-member-new"
      v-if="coupon.couponMemberType == 3"
      v-track="{
        act: 'show',
        params: { cfrom: '081|067|02|077', event_id: '081|067|02|077', coupon_id: coupon.couponUuid }
      }"
    >
      <span>新人专享</span>
    </div>
    <div
      class="new-member-new"
      v-else-if="coupon.couponMemberType == 4"
      v-track="{
        act: 'show',
        params: { cfrom: '081|067|02|077', event_id: '081|067|02|077', coupon_id: coupon.couponUuid }
      }"
    >
      <span>学生专享</span>
    </div>
    <div class="left-top" v-else-if="coupon.memberLevelCode > 1" :aria-label="memberLevelName">
      <img :src="coupon.levelIconWithTextUrl" />
    </div>
    <div :class="couponInfo">
      <div class="coupon-wrap">
        <div class="icon-top"></div>
        <div class="icon-bottom" :style="isShowDesc ? 'background: #FFFFFF;' : ''"></div>
        <div :class="left" tabindex="0">
          <div :class="['amount', (coupon.couponAmount + '').length >= 4 ? 'large' : '']">
            <template v-if="coupon.couponFlag == 2">免息</template>
            <template v-else-if="coupon.couponRuleType == '4001'">免邮</template>
            <template v-else-if="coupon.couponRuleType == '6661'">免息</template>
            <template v-else-if="coupon.couponRuleType == '5001'">
              <span class="int">{{ coupon.discount }}</span>
              <!-- <span class="decimal" v-if="coupon.discount % 1 !== 0">.{{ (coupon.discount + '').split('.')[1] }}</span> -->
              <span class="text">折</span>
            </template>
            <template v-else>
              <b>
                <span class="yen">&yen;</span>
                <span class="number">{{ coupon.couponAmount }}</span>
              </b>
            </template>
          </div>
          <template v-if="coupon.couponRuleType == '6661'">
            <div :class="['left-bottom', 'coupon-type-6661']" class="fs-30">
              {{ coupon.nameTip }}
            </div>
          </template>
          <template v-else>
            <div :class="couponType" class="fs-30">
              {{ couponName }}
            </div>
          </template>
        </div>
        <div :class="right">
          <div class="right-middle">
            <div class="instru">
              <div class="desc fs-42">
                <template v-if="coupon.couponFlag == 2">
                  {{ coupon.couponRuleDesc || coupon.ruleDesc }}
                </template>
                <template v-else-if="coupon.couponRuleType == '4001'">订单满{{ coupon.arriveAmount }}免邮</template>
                <template v-else-if="coupon.couponRuleType == '5001'">
                  满{{ coupon.arriveAmount }}元{{ coupon.discount }}折 上限{{ coupon.ceiling }}元
                </template>
                <template v-else-if="coupon.couponRuleType == '2001'">特定商品减{{ coupon.subAmount }}</template>
                <template v-else-if="coupon.couponRuleType == '1001'">
                  单品满{{ coupon.arriveAmount }}减{{ coupon.subAmount }}
                </template>
                <template v-else-if="coupon.couponRuleType == '3001'">
                  订单满{{ coupon.arriveAmount }}减{{ coupon.subAmount }}
                </template>
                <template v-else-if="coupon.couponRuleType == '6661' && coupon.ruleDesc">
                  {{ coupon.ruleDesc }}
                </template>
                <template v-else>满{{ coupon.arriveAmount }}减{{ coupon.subAmount }}</template>
              </div>
            </div>
            <div class="right-container">
              <p :class="['time', timeSet(coupon).class]" v-if="coupon.beginTimeStr">
                {{ timeSet(coupon).time }}
              </p>
              <template v-if="type === 0 || type === 1">
                <template v-if="btnType === 1">
                  <v-checkbox v-model="isSelect" scale="0.82"></v-checkbox>
                </template>
                <!-- 券包列表页（未使用）->各券“去使用”点击 -->
                <template v-else-if="btnType == 0">
                  <!-- <a @click="trackClick" v-if="env.isVHome" :class="btn" :href="path.iot">立即使用</a> -->
                  <!-- <template v-else> -->
                  <a
                    @click="trackClick"
                    v-if="coupon.wapUseUrl == '' || coupon.wapUseUrl == null"
                    :class="btn"
                    :href="`${linkBase}/index.html`"
                  >
                    立即使用
                  </a>
                  <a @click="trackClick" v-else :class="btn" :href="coupon.wapUseUrl">立即使用</a>
                  <!-- </template> -->
                </template>
              </template>
              <template v-else-if="type === 4 && !isReceive">
                <a :class="btn" href="javascript:void(0);" @click="receive">立即领取</a>
              </template>
            </div>
          </div>
          <div :class="['right-bootom', isShowDesc ? 'open' : '']" tabindex="0" @click.stop="handleToggle">
            <p class="name fs-30">{{ coupon.couponName }} {{ coupon.calculateCommodityType == 2 ? '限买1件' : '' }}</p>
            <p v-if="coupon.description" class="toggle"></p>
          </div>
        </div>
      </div>
      <div :class="iconStyle"></div>
    </div>

    <!-- <div class="bootom-desc"> -->
    <!-- <collapse> -->
    <!-- <div :class="coupon.description && isShowDesc ? 'desc-enter transition-enter' : 'desc-leave transition-leave'">
        <p v-html="coupon.description"></p>
      </div> -->
    <!-- </collapse> -->
    <!-- </div> -->
    <div :class="['bootom-desc', isShowDesc ? 'open' : '']">
      <collapse>
        <div v-if="coupon.description && isShowDesc" class="desc-open" :data-in-swiper="isInSwiper">
          <p v-html="coupon.description"></p>
        </div>
      </collapse>
    </div>
  </div>
</template>

<script>
import create from '../create' // 使其变成v-coupon形式
import config from 'config' // 配置
import env from 'utils/clientEnv' // 环境判断
import { receiveCoupon, receiveLiveCoupon } from './api'

const couponName = {
  // 券名字
  1001: '优惠券',
  2001: '优惠券',
  3001: '优惠券',
  4001: '免邮券',
  5001: '折扣券'
}

export default create({
  props: {
    type: {
      // 券类型 0是未使用券 1代表商详页已经领取的券 2是已经使用券 3是过期券 4代表商详页可以领券 5代表升级后可领的券
      type: [String, Number],
      default: 0
    },
    btnType: {
      // 右边按钮类型 0是立即使用按钮 1是打勾按钮
      type: [String, Number],
      default: 0
    },
    coupon: {
      // 券数据
      type: Object,
      default: {},
      required: true
    },
    couponFlag: {
      // 券的类型判断 0是优惠券类型 1是代金券
      type: [String, Number],
      default: 0
    },
    isSelect: {
      // 是否选中
      type: Boolean
    },
    hasReceive: {
      // 单独为商详页面标识是否已经领取
      type: Boolean,
      default: false
    },
    useCouponClick: {
      type: Object
    },
    isInSwiper: {
      // 我的优惠券页面swiper嵌套的场景
      type: Boolean,
      default: false
    },
    // 经度 纬度
    longitude: [String, Number],
    latitude: [String, Number]
    // couponMemberType 1：所有用户 2：vivo员工 3：商城新用户
  },
  name: 'coupon',
  data() {
    return {
      isReceive: false, // 组件内自身状态 是否已经点击立即领取按钮
      isShowDesc: false, // 是否显示券说明
      env: env, // 环境判断
      path: config.path, // 路径
      initTime: Date.now()
    }
  },
  computed: {
    // 动态设置会员类型样式
    // plusType() {
    //   return ['left-top', `plus-type-${this.coupon.memberLevelCode}`]
    // },
    // 会员名字 白银会员 黄金会员
    memberLevelName() {
      const levelCode = this.coupon.memberLevelCode
      if (levelCode === 2) return '白银会员'
      else if (levelCode === 3) return '黄金会员'
      else if (levelCode === 4) return '钻石会员'
    },
    // 左边券的背景图 红色 橙色 蓝色
    left() {
      // couponFlag 0优惠券、1代金券、2免息券
      let flag = this.coupon.couponFlag || this.couponFlag
      let type = this.type
      if (type === 2 || type === 3) return ['left']
      else if (flag == 1) return ['left', 'left-coupon-type-daijin']
      else if (flag == 2) return ['left', 'left-coupon-type-mianxi']
      else return ['left', `left-coupon-type-${this.coupon.couponRuleType}`]
    },
    // 右边券的背景图 红色 橙色 蓝色
    right() {
      let flag = this.coupon.couponFlag || this.couponFlag
      let type = this.type
      if (type === 2 || type === 3) return ['right']
      else if (flag == 1) return ['right', 'right-coupon-type-daijin']
      else if (flag == 2) return ['right', 'right-coupon-type-mianxi']
      else return ['right', `right-coupon-type-${this.coupon.couponRuleType}`]
    },
    // 根据券类型来设置券样式
    couponType() {
      let flag = this.coupon.couponFlag || this.couponFlag
      let type = this.type
      if (type === 2 || type === 3) {
        return ['left-bottom']
      } else if (flag === 1) {
        return ['left-bottom', 'coupon-type-daijin']
      } else if (flag === 2) {
        return ['left-bottom', 'coupon-type-mianxi']
      } else {
        return ['left-bottom', `coupon-type-${this.coupon.couponRuleType}`]
      }
    },
    // icon类型
    iconStyle() {
      let type = this.type
      if (this.isReceive) {
        return 'received-icon'
      } else {
        const iconStyleBus = ['icon-default', 'icon-default', 'used-icon', 'expired-icon']
        return iconStyleBus[type]
      }
    },
    // 动态设置券底部点击出现的券说明样式
    couponInfo() {
      // if (this.isShowDesc == true) return ['coupon-info', 'show-shadow']
      // else return ['coupon-info']
      return ['coupon-info']
    },
    // 根据 couponFlag(券类型) 和 couponRuleType(不同类型券的券规则) 来设置券名字
    couponName() {
      let flag = this.coupon.couponFlag || this.couponFlag
      if (flag === 1) return '代金券'
      else if (flag === 2) return (this.coupon.couponRuleDesc || this.coupon.ruleDesc).split('免息')[0]
      else return couponName[this.coupon.couponRuleType]
    },
    // 根据 type 来设置按钮的样式
    btn() {
      if (this.type === 1) return 'btn-default'
      else return 'btn-default'
    },
    timeSet() {
      return function ({ beginTime, endTime }) {
        const beginTimeDate = new Date(beginTime)
        const bY = beginTimeDate.getFullYear()
        const bM = (beginTimeDate.getMonth() + 1).toString().padStart(2, '0')
        const bd = beginTimeDate.getDate().toString().padStart(2, '0')
        const bh = beginTimeDate.getHours().toString().padStart(2, '0')
        const bm = beginTimeDate.getMinutes().toString().padStart(2, '0')
        const endTimeDate = new Date(endTime)
        const eY = endTimeDate.getFullYear()
        const eM = (endTimeDate.getMonth() + 1).toString().padStart(2, '0')
        const ed = endTimeDate.getDate().toString().padStart(2, '0')
        const eh = endTimeDate.getHours().toString().padStart(2, '0')
        const em = endTimeDate.getMinutes().toString().padStart(2, '0')
        // 可用
        if (this.initTime >= beginTimeDate && this.initTime <= endTimeDate) {
          return {
            time: `有效期至${eY}.${eM}.${ed} ${eh}:${em}`,
            class: 'nowrap'
          }
        } else {
          // 待可用 / 已过期
          return {
            time: `${bY}.${bM}.${bd} ${bh}:${bm} ~ ${eY}.${eM}.${ed} ${eh}:${em}`,
            class: 'normal'
          }
        }
      }
    }
  },
  watch: {
    isShowDesc(isShow) {
      if (this.coupon.description) {
        if (isShow) {
          this.$emit('toggleDesc', true)
        } else {
          this.$emit('toggleDesc', false)
        }
      }
    }
  },
  created() {},
  mounted() {
    this.isReceive = this.hasReceive
  },
  methods: {
    // 切换券底部使用说明
    handleToggle() {
      if (this.coupon?.description) {
        this.isShowDesc = !this.isShowDesc
        // 执行传入的方法
        this.$emit('more')
      }
    },
    /**
     * @description: 改变选择的券id
     * @param id {String}
     * @return: viod
     */
    changeSelect(id) {
      this.$emit('changeSelect', id)
    },
    receive() {
      let param = {
        couponUuid: this.coupon.couponUuid,
        comeFrom: 'vivoshop_h5'
      }
      if (this.longitude || this.latitude) {
        param.longitude = this.longitude
        param.latitude = this.latitude
      }
      if (this.coupon.liveChannel) {
        receiveLiveCoupon(param)
          .then(() => {
            this.isReceive = true
            this.toastSuccess('领券成功')
          })
          .catch(e => {
            e.msg && this.$toast(e.msg)
          })
      } else {
        receiveCoupon(param)
          .then(() => {
            this.isReceive = true
            this.toastSuccess('领券成功')
          })
          .catch(e => {
            e.msg && this.$toast(e.msg)
          })
      }

      // 领取后执行传入的方法
      this.$emit('callback')
      if (this.coupon.couponMemberType == 3) {
        this.$track({
          cfrom: '081|067|01|077',
          event_id: '081|067|01|077'
        })
      }
    },
    goUse() {
      this.$emit('callback')
    },
    // TODO:需要确认公控样式，公控不存在该类样式
    toastSuccess(msg) {
      this.$toast({
        type: 'success',
        message: msg
      })
    },
    // 券点击埋点
    trackClick() {
      let type = this.type
      let params = null
      let urlNext = null
      if (type == 1) {
        params = this.useCouponClick
      } else {
        // if (this.env.isVHome) {
        //   urlNext = this.path.iot
        // } else
        if (this.coupon.wapUseUrl == '' || this.coupon.wapUseUrl == null) {
          urlNext = `${this.linkBase}/index.html`
        } else {
          urlNext = this.coupon.wapUseUrl
        }
        params = {
          url_next: urlNext,
          coupon_no: this.coupon.couponNum
        }
      }
      this.$emit('trackClick', params)
    }
  }
})
</script>

<style lang="scss" scoped src="./index.scss"></style>
